import AirbrakeClient from 'airbrake-js';

let airbrakeInstance = null;

const SEVERITY_LEVEL = {
  DEBUG: 'debug',
  ERROR: 'error',
  INFO: 'info'
};

const makeLoggerWithSeverity = severity => {
  return (err, annotations = {}) => {
    if (!airbrakeInstance) {
      throw new Error('Airbrake has not been initialized');
    }

    airbrakeInstance.notify({
      error: err,
      context: { severity },
      ...annotations
    });
  };
};

const logger = {
  debug: makeLoggerWithSeverity(SEVERITY_LEVEL.DEBUG),
  error: makeLoggerWithSeverity(SEVERITY_LEVEL.ERROR),
  info: makeLoggerWithSeverity(SEVERITY_LEVEL.INFO)
};

const initialize = ({ appVersion, environment, isDebug = false, isSdk, projectId, projectKey }) => {
  airbrakeInstance = new AirbrakeClient({
    environment,
    projectId,
    projectKey
  });

  // add environment and appVersion to context
  airbrakeInstance.addFilter(notice => {
    notice.context.environment = environment;
    notice.context.isSdk = isSdk;
    notice.context.version = appVersion;

    return notice;
  });

  // prevent pushing notices to Airbrake API when debugging
  airbrakeInstance.addFilter(notice => {
    if (!isDebug) {
      return notice;
    }

    console.group('%cAirbrake logger is in debug mode, logging notice to console:', 'color:yellow'); // eslint-disable-line no-console
    console.log(notice); // eslint-disable-line no-console
    console.groupEnd(); // eslint-disable-line no-console

    return null;
  });

  return logger;
};

const getInstance = () => {
  if (!airbrakeInstance) {
    throw new Error('Airbrake has not been initialized');
  }

  return logger;
};

export { initialize, getInstance };
